import React, { useEffect, useRef, useState } from "react";
import { isEmpty } from "lodash";
import { useParams } from "react-router-dom";

import MyAccountLayout from "./MyAccountLayout";
import MyAccountFilter from "./MyAccountFilter";
import Pagination from "../../components/Pagination";
import { apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import {
  formatDate,
  toFixedWithoutRounding,
  levelMap,
} from "../../Utils/Constant";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";

const TransactionHistory = () => {
  const { id } = useParams();
  const [summaryData, setSummaryData] = useState({});

  const getSummary = async () => {
    const url = `${apiPath.userProfile}?user_id=${!isEmpty(id) ? id : user?._id}`;
    const { status, data: response_users } = await apiGet(url);
    if (status === 200 && response_users.success) {
      setSummaryData(response_users.results);
    }
  };

  useEffect(() => {
    if (!isEmpty(id)) {
      getSummary();
    }
  }, [id]);
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const tableRef = useRef();

  const DEFAULT_FILTER = {
    page: 1,
    limit: 10,
    user_id: id || undefined,
  };

  const [filter, setFilter] = useState(DEFAULT_FILTER);
  const [data, setData] = useState({});

  const getData = async (activeFilter) => {
    const { status, data: response_users } = await apiGet(
      apiPath.transactionLogs,
      activeFilter,
    );
    if (status === 200 && response_users.success) {
      setData(response_users.results);
    }
  };

  useEffect(() => {
    getData(filter);
  }, [filter.page, filter.limit]);

  const handleLimitChange = (e) => {
    setFilter((prev) => ({ ...prev, limit: Number(e.target.value), page: 1 }));
  };

  const handlePageChange = (newPage) =>
    setFilter((prev) => ({ ...prev, page: newPage }));

  const handleShowDefault = () => {
    setFilter(DEFAULT_FILTER);
    if (
      filter.page === DEFAULT_FILTER.page &&
      filter.limit === DEFAULT_FILTER.limit
    ) {
      getData(DEFAULT_FILTER);
    }
  };

  const rows = data?.data || [];

  const totals = rows.reduce(
    (acc, item) => ({
      deposit: acc.deposit + Number(item?.depositFromUpline || 0),
      withdraw: acc.withdraw + Number(item?.wihtDrawByUpline || 0),
      depositUpline: acc.depositUpline + Number(item?.depositToDownline || 0),
      withdrawUpline:
        acc.withdrawUpline + Number(item?.withDrawFromDownline || 0),
    }),
    {
      deposit: 0,
      withdraw: 0,
      depositUpline: 0,
      withdrawUpline: 0,
    },
  );
  return (
    <MyAccountLayout>
      <div id="report" className="col-center report">
        <div className="box" style={{ alignItems: "center" }}>
          <h2>Transaction History</h2>
        </div>

        <div className="push">
          <div className="download-reports">
            <ul style={{ marginBottom: "8px" }} className="acc-info">
              <li className="">
                <span
                  className={`Bdlevel ${levelMap[summaryData?.userType]}`}
                />{" "}
                {summaryData?.username}
              </li>
            </ul>
            <div className="spacer" />
            <span>
              <label className="last">Last:</label>
              <select
                name="limit"
                id="limit"
                value={filter.limit}
                onChange={handleLimitChange}
              >
                <option value={100}>100 Txn</option>
                <option value={50}>50 Txn</option>
                <option value={25}>25 Txn</option>
                <option value={10}>10 Txn</option>
              </select>
            </span>
            <MyAccountFilter
              type={"new"}
              tableRef={tableRef}
              fileName="activity-log"
            />
            <a
              id="default"
              className="btn_replay"
              title="Show Default"
              onClick={(e) => {
                e.preventDefault();
                handleShowDefault();
              }}
            >
              <i className="fas fa-redo-alt" />
            </a>
          </div>
        </div>

        <ul className="acc-info">
          <li className="user" />
          <li className="status_all" />
        </ul>

        <div className="table-responsive data-table">
          <table ref={tableRef} id="table_log" className="table01">
            <tbody>
              <tr>
                <th width="13%" className="align-L sort_asc">
                  Date/Time
                </th>
                <th width="13%" className="sort_asc">
                  Deposit By Upline
                </th>{" "}
                {summaryData?.userType != "user" && (
                  <th width="13%" className="sort_asc">
                    Deposit To Downline
                  </th>
                )}
                <th width="13%" className="sort_asc">
                  WihtDraw By Upline
                </th>{" "}
                {summaryData?.userType != "user" && (
                  <th width="13%" className="sort_asc">
                    WihtDraw From Downline
                  </th>
                )}
                <th width="13%" className="sort_asc">
                  Balance
                </th>
                <th width="13%" className="sort_asc">
                  Remark
                </th>
                <th width="13%">From/To</th>
              </tr>
            </tbody>
            <tbody id="content">
              {!isEmpty(rows) ? (
                rows.map((item, key) => (
                  <tr key={key} id="tempTr">
                    <td id="createDate" className="align-L">
                      {formatDate(item?.createdAt, user?.timeZone)}
                    </td>

                    <td className="betgameactive">
                      {item?.depositFromUpline ? (
                        <span className="">
                          {toFixedWithoutRounding(
                            Math.abs(item?.depositFromUpline),
                          )}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>

                    {summaryData?.userType != "user" && (
                      <td className="betgameactive">
                        {item?.depositToDownline ? (
                          <span className="">
                            {toFixedWithoutRounding(
                              Math.abs(item?.depositToDownline),
                            )}
                          </span>
                        ) : (
                          "-"
                        )}
                      </td>
                    )}
                    <td>
                      {item?.wihtDrawByUpline ? (
                        <span className="red">
                          {toFixedWithoutRounding(item?.wihtDrawByUpline)}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>

                    {summaryData?.userType != "user" && (
                      <td className="betgameactive">
                        {item?.withDrawFromDownline ? (
                          <span className="red">
                            {toFixedWithoutRounding(
                              Math.abs(item?.withDrawFromDownline),
                            )}
                          </span>
                        ) : (
                          "-"
                        )}
                      </td>
                    )}
                    <td id="balance">
                      { toFixedWithoutRounding(item?.newBalance1 > 0 ? item?.newBalance1 : item?.newBalance)}
                    </td>
                    <td id="remark">{"Fund Transfer"}</td>

                    <td>
                      {item?.forBet != 0
                        ? `${
                            item?.eventType === "4"
                              ? "Cricket"
                              : item?.eventType === "1"
                                ? "Soccer"
                                : item?.eventType === "2"
                                  ? "Tennis"
                                  : "Casino"
                          }
                                    / Match /
                                    ${item?.matchName} / ${
                                      item?.eventId
                                    } / ${item?.runnerName}`
                        : `${item?.formToData || ""}`}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6}>No records found</td>
                </tr>
              )}
              <tr class="total">
                <td class="align-L">Total</td>
                <td id="_totalDepositbyUpline">
                  <span> {toFixedWithoutRounding(totals?.deposit)} </span>
                </td>
                {summaryData?.userType != "user" && (
                  <td id="_totalDepositbyUpline">
                    <span>
                      {" "}
                      {toFixedWithoutRounding(totals?.depositUpline)}{" "}
                    </span>
                  </td>
                )}
                <td id="_totalWithdrawUpline">
                  <span> {toFixedWithoutRounding(totals?.withdraw)}</span>
                </td>

                {summaryData?.userType != "user" && (
                  <td id="_totalDepositbyUpline">
                    <span>
                      {" "}
                      {toFixedWithoutRounding(totals?.withdrawUpline)}{" "}
                    </span>
                  </td>
                )}

                <td>
                  {" "}
                  {/* <span> {toFixedWithoutRounding(totals?.balance)} </span> */}
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>

          {rows.length > 0 && data?.totalDocs > 0 && (
            <Pagination pagination={data} onPageChange={handlePageChange} />
          )}
        </div>
      </div>
    </MyAccountLayout>
  );
};

export default TransactionHistory;
